export const APPLY_EDITOR_SETTINGS = '@date-picker/APPLY_SETTINGS';
